import type { MonthlyTable } from "@/lib/types";

const TABLE_ORDER = ["yoga", "pdc", "bcaris", "devotees", "employees"] as const;

/** Keep Yoga, PDC, Bcaris, and Employees as separate tables (legacy `devotees` still sorts). */
export function orderedAdminTables(tables: MonthlyTable[]): MonthlyTable[] {
  const map = new Map(tables.map((t) => [t.key, t]));
  const ordered: MonthlyTable[] = [];
  for (const key of TABLE_ORDER) {
    const table = map.get(key);
    if (table) ordered.push(table);
  }
  for (const table of tables) {
    if (!ordered.includes(table)) ordered.push(table);
  }
  return ordered;
}

export function tableSubtitle(tableKey: string): string {
  if (tableKey === "employees") {
    return "AM · PM per day (left = morning 9–1, right = evening 5–9)";
  }
  if (tableKey === "pdc" || tableKey === "bcaris") {
    return "One cell per day — same morning schedule as Yoga";
  }
  if (tableKey === "yoga") {
    return "One cell per day (morning program)";
  }
  return "One cell per day per person in this group";
}

export function tableShowsShifts(tableKey: string): boolean {
  return tableKey === "employees";
}
